module.exports = __webpack_public_path__ + "img/xnes-progress-page.5c9d0419.svg";